module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_PRPOTEINPOWER.214c7d64.png";